import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import ProgressImage from '../progress-image';

import './project-image.css';

const ProjectImage = ({
  block,
  imageProps,
}) => {
  const image = block.getIn(['fields', 'image', 'value']);
  const caption = block.getIn(['fields', 'caption', 'value']);
  const inProgress = block.getIn(['fields', 'inProgress', 'value']);

  const classes = ['project-image'];
  if (inProgress) classes.push('in-progress');

  return (
    <div className={classes.join(' ')}>
      <ProgressImage image={image ? image.toJS() : null} {...imageProps} />
      {caption ? <div className="caption">{caption}</div> : null}
    </div>
  );
};

ProjectImage.propTypes = {
  block: PropTypes.instanceOf(Map).isRequired,
  imageProps: PropTypes.object,
};

ProjectImage.defaultProps = {
  imageProps: {},
};

export default ProjectImage;



// WEBPACK FOOTER //
// ./src/components/project-image/index.jsx